import { ProjectListColumn, ProjectListColumnKey } from 'src/modules/project-list/types/ProjectListColumn';

export const PROJECT_LIST_DEFAULT_COLUMNS: ReadonlyArray<ProjectListColumn> = [
  { enabled: true, key: ProjectListColumnKey.MEMBERS },
  { enabled: true, key: ProjectListColumnKey.STATUS },
  { enabled: true, key: ProjectListColumnKey.UPDATED },
  { enabled: false, key: ProjectListColumnKey.ROI },
  { enabled: false, key: ProjectListColumnKey.ROI_2 },
  { enabled: false, key: ProjectListColumnKey.ROI_5 },
  { enabled: false, key: ProjectListColumnKey.BEP },
];

export const PROJECT_LIST_COLUMNS_VERSION = '15.10.2025';
